import styled from 'styled-components';

export const StyledFooterButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    width: 100%;

    & button:first-of-type {
      order: 1;
    }
  }
`;
